import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const Loading = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="100%">
    <CircularProgress />
  </Box>
);

export default Loading;
